export const SET_STATE = 'hotelQuerySearch/SET_STATE';
export const SET_FETCHING = 'hotelQuerySearch/SET_FETCHING';
export const SET_INPUT_VALUE = 'hotelQuerySearch/SET_INPUT_VALUE';
export const SET_RESULTS = 'hotelQuerySearch/SET_RESULTS';
export const RESET_STATE = 'hotelQuerySearch/RESET_STATE';
